import type { AppRibbonProps } from 'owa-app-ribbon';
import { getMailCommandRibbonProps } from './getMailCommandRibbonProps';
import { renderExtraMailCommandComponents } from './renderExtraMailCommandComponents';
import categoryStore from 'owa-categories/lib/store/store';
import moveToStore from 'owa-mail-moveto-control/lib/store/store';

export const mailAppRibbonProps: AppRibbonProps = {
    getRibbonProps: getMailCommandRibbonProps,
    renderExtraElements: renderExtraMailCommandComponents,
    ribbonPropsDependency1: categoryStore.categoryMenuViewState.findText,
    ribbonPropsDependency2: moveToStore.findText,
};
